const IsEmail = require('isemail');
export const required = (message) => (value) => {
    if (value === undefined || (typeof value === 'string' && value === ''))
        return message || '';
};
export const email = (message) => (value) => {
    if (typeof value !== 'string' || (!isEmail(value) && value !== ''))
        return message || '';
};
export const number = (message) => (value) => {
    if (!!isNaN(Number(value)))
        return message || '';
};
export const same = (field, message) => {
    return (value, form) => {
        if (form.getValidated(field) && value !== form.getValue(field))
            return message || '';
    };
};
const isEmail = (email) => IsEmail.validate(email, { minDomainAtoms: 2 });
